export function filterArrayOfObjectsByString(searchTerm, dataSource) {
  const filteredArray = dataSource.filter((item) => {
    const itemString = JSON.stringify(item).toLowerCase();
    return itemString.includes(searchTerm.toLowerCase());
  });

  return filteredArray;
}
